import MultiSelectDropdown from 'components/MultiSelectDropdown';
import { useAtom, useAtomValue } from 'jotai';
import React, { useEffect } from 'react';
import { Row, Col } from 'reactstrap';

import DashboardActions from './DashboardActions';
import {
  paginationConfigAtom,
  selectedAccountIdListAtom,
  selectedHostTypeListAtom,
  selectedStateFiltersListAtom,
} from './state';
import {
  HostType,
  RepositoryFilterOptions,
  getEnumKeyByEnumValue,
  getHostLabel,
} from '../helper';
import { accountsTitlesAtom } from '../state';

const Filters = () => {
  const [selectedAccountIds, setSelectedAccountIds] = useAtom(
    selectedAccountIdListAtom,
  );
  const [paginationConfig, setPaginationConfig] = useAtom(paginationConfigAtom);
  const [selectedHostTypes, setSelectedHostTypes] = useAtom(
    selectedHostTypeListAtom,
  );

  const [selectedStateFilters, setSelectedStateFilters] = useAtom(
    selectedStateFiltersListAtom,
  );

  const accountsTitles = useAtomValue(accountsTitlesAtom);

  useEffect(
    () => {
      // parse the query string and get the value of 'account_id'
      const params = new URLSearchParams(window.location.search);
      const accountIdParam = params.get('account_id');
      if (accountIdParam) {
        setSelectedAccountIds([parseInt(accountIdParam)]);
      }
    },
    [
      /* first load */
    ],
  );

  const accountsList = (): any[] => {
    if (selectedHostTypes?.length === 0) return accountsTitles;
    return accountsTitles?.filter((x) =>
      selectedHostTypes.includes(x['host_type']),
    );
  };

  return (
    <Row className="text-left">
      <DashboardActions />
      <Col>
        <MultiSelectDropdown
          options={Object.values(HostType).map((host) => ({
            value: host,
            label: getHostLabel(host),
          }))}
          selectedOptions={selectedHostTypes?.map((host) => {
            const hostType = host as HostType;
            return {
              value: host,
              label: getHostLabel(hostType),
            };
          })}
          onSelectionChange={(selectedOptions) => {
            setSelectedHostTypes(
              selectedOptions?.map((host) => host.value) || [],
            );
            // reset accounts selection
            setSelectedAccountIds([]);
            setPaginationConfig({ ...paginationConfig, page: 1 });
          }}
          placeholderText="Filter by type ..."
        />
      </Col>
      <Col>
        <MultiSelectDropdown
          options={accountsList()?.map((account) => ({
            value: account.id,
            label: account.title,
          }))}
          selectedOptions={accountsList()
            ?.filter((account) => selectedAccountIds?.includes(account.id))
            ?.map((account) => ({ value: account.id, label: account.title }))}
          onSelectionChange={(selectedOptions) => {
            setSelectedAccountIds(
              selectedOptions?.map((account) => parseInt(account.value)) || [],
            );
            setPaginationConfig({ ...paginationConfig, page: 1 });
          }}
          placeholderText="Filter by account ..."
        />
      </Col>
      <Col>
        {/* <MultiSelectDropdown
          options={Object.keys(RepositoryFilterOptions).map((key) => ({
            value: key,
            label:key,
          }))}
          selectedOptions={selectedStateFilters?.map((value) => {
            const filter = value as RepositoryFilterOptions;
            return {
              value: RepositoryFilterOptions[filter],
              label: RepositoryFilterOptions[filter],
            };
          })}
          onSelectionChange={(selectedOptions) => setSelectedStateFilters(selectedOptions?.map(x => RepositoryFilterOptions[x.value]) || [])}
          placeholderText="filter by state ..."
        /> */}
        <MultiSelectDropdown
          options={Object.values(RepositoryFilterOptions).map((value) => ({
            value: value, // Use enum key as value
            label: getEnumKeyByEnumValue(RepositoryFilterOptions, value),
          }))}
          selectedOptions={selectedStateFilters?.map((value) => ({
            value: value,
            label: getEnumKeyByEnumValue(RepositoryFilterOptions, value),
          }))}
          onSelectionChange={(selectedOptions) => {
            setSelectedStateFilters(selectedOptions?.map((x) => x.value) || []);
            setPaginationConfig({ ...paginationConfig, page: 1 });
          }}
          placeholderText="Filter by state ..."
        />
      </Col>
    </Row>
  );
};

export default Filters;
